import React from 'react';
import { graphql, HeadProps, PageProps } from 'gatsby';
import Layout from '../../component/Layout';
import RecentArticles from '../../component/RecentArticles';
import { Common, SanityImage, SanitySEO, SanitySlug, SanityTeaser, SanityArticleTag } from '../../types/common';
import { formatDate } from '../../utils/formatDate';
import { urlFor } from '../../utils/imageBuilder';
import RichText from '../../component/RichText';
import Hero from '../../component/Hero';
import { ArticlePreview } from '../../types/articlePreview';
import './styles.scss';
import SocialShare from '../../component/SocialShare';
import { SEO } from '../../component/SEO';

export const data = graphql`
  query($_id: String) {
    sanityArticles(_id: { eq: $_id }) {
      ...articlesAllFields
    }
    allSanityArticles(sort: {_createdAt: DESC}, limit: 5) {
      ...ArticlesPreviewList
    }
    ...Common
  }
`;

type propsArticle = {
  sanityArticles: {
    _id: string;
    _createdAt: string;
    parentPage: {
      id: string;
      slug: SanitySlug;
    }
    slug: SanitySlug;
    seo: SanitySEO;
    title: string;
    image: SanityImage;
    _rawBody: any;
    teaser: SanityTeaser;
    tags?: SanityArticleTag | null;
  }
  allSanityArticles: {
    nodes: ArticlePreview[];
  };
} & Common

const Articles = ({ data }: PageProps<propsArticle>) => {
  const articleData = data.sanityArticles;
  const recentArticles = data.allSanityArticles.nodes?.filter(article => article._id !== articleData._id)?.slice(0, 4);

  return (
    <Layout common={data}>
      <Hero
        title={articleData.title}
        breadcrumb={articleData}
      />
      <section className='article-page'>
        {articleData.image && (
          <img
            src={urlFor(articleData.image).width(550).quality(90).url()}
            alt={articleData.image.alt}
          />
        )}
        {/* <span className='date'>{formatDate(articleData._createdAt)}</span> */}
        <div className='article-content'>
          <RichText
            value={articleData._rawBody}
          />
        </div>
        <SocialShare
          message={`${articleData.title}`}
        />
      </section>
      <RecentArticles
        articles={recentArticles}
      />
    </Layout>
  );
};

export default Articles;

export function Head({ data }: HeadProps<propsArticle>) {
  return (
    <>
      <SEO data={data.sanityArticles} settings={data.sanitySiteSettings} />;
      <meta property="og:title" content={data.sanityArticles.seo.metaTitle} />
      {data.sanityArticles.seo.metaDescription && (
        <meta property="og:description" content={data.sanityArticles.seo.metaDescription} />
      )}
      <meta property="og:type" content="article" />
      <meta property="og:image" content={urlFor(data.sanityArticles.image).url()} />
    </>
  )
}
